import _ from 'lodash'
import React from 'react'
import { Helmet } from 'react-helmet'
import Overlay from '~/components/Overlay'
import share from '~/tools/share'
import filterCredits from '~/tools/filterCreditBlocks'
import { trackEvent } from '~/tools/analytics/cleverTap'
import Modal from '~/components/Modal'
import VideoJSPlayer from '~/components/VideoPlayer'
import { getUser } from '~/redux/user/helpers'
import popup from "~/views/Popup/popup";
import Timer from '~/components/Timer'
import { PlayCircleSvg } from '~/components/VideoPlayer/assets/icons'
import {
  getVideoInfo,
  addToQueue,
  removeFromQueue,
  getTransactionInfo,
  playVideo
} from "~/redux/uservideo/helpers";
import { AddToWatchlistIcon, RemoveFromWatchlistIcon } from '~/assets/svg'

import connect from "~/tools/connect";
import userStore from '~/redux/user/store';

import './style.css'

class VideoPlayerWithInfo01 extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      video: _.get(props.data, 'contentData[0]'),
      isModelOpen: false,
      pricingOptions: _.get(props.data, 'contentData[0].pricing'),
      isQueued: false
    }

    this.showTrailer = this.showTrailer.bind(this)
    this.addToQueue = this.addToQueue.bind(this)
    this.removeFromQueue = this.removeFromQueue.bind(this)
    this.socialShare = this.socialShare.bind(this)
  }

  bodyHack(shown) {
    const bcl = window.document.body.classList
    if (bcl && shown) {
      bcl.add('overflow-hide')
    } else if (bcl && bcl.contains('overflow-hide')) {
      bcl.remove('overflow-hide')
    }
  }

  showTrailer() {
    this.bodyHack(!this.state.isModelOpen)
    this.setState({ isModelOpen: !this.state.isModelOpen })
  }

  componentDidMount() {
    this.getVideoInfo()
    if(this.state.video === undefined) return;
    this.state.video.pricing && this.getTransactionInfo()
  }

  getTransactionInfo() {
    var { contentType, id } = this.state.video.gist;
    getUser(user => {
      if (!user) {
        this.setState({
          purchased: false
        })
        return
      }
      if (user && user.isSubscribed && this.state.video.pricing.type && this.state.video.pricing.type.includes("SVOD+")) {
        this.setState({
          purchased: true
        })
        return
      }
      getTransactionInfo(user.userId, false, contentType, id).then(res => {
        if (res.data && res.data[0][id]) {
          this.setState({
            purchased: true
          })
        } else {
          this.setState({ purchased: false })
        }
      })
    })
  }

  getVideoInfo() {
    if(this.state.video === undefined) return;
    var id = this.state.video.gist.id
    getUser(user => {
      if (!user) {
        return
      }
      getVideoInfo(id, data => {
        this.setState({
          isQueued: data.isQueued,
          startTime: data.watchedTime,
        })
      })
    })
  }

  disableRightClick(e) {
    e.preventDefault()
  }

  addToQueue() {
    const {gist = {}, creditBlocks = [], categories = []} = this.state.video
    const id = gist.id
    const contentType = gist.contentType

    addToQueue(id, contentType, data => {
      categories.push(gist.primaryCategory)
      var addToQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.mediaType === 'EPISODIC' ? 'Episode' : 'Video',
        contentDuration: gist.runtime,
        playbackType: 'Streamed'
      }
      creditBlocks.forEach(creditBlock => {
        if(creditBlock.title.trim().toLowerCase() === 'director'){
          addToQueueEventData.directorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
        if(creditBlock.title.trim().toLowerCase() === 'starring'){
          addToQueueEventData.actorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
      })
      addToQueueEventData.contentGenre = categories.map(category => category && category.title).join(',')
      trackEvent('Added to Watchlist', addToQueueEventData)
      this.setState({ isQueued: true })
    })
  }

  removeFromQueue() {
    const {gist = {}, creditBlocks = [], categories = []} = this.state.video
    const id = gist.id
    
    removeFromQueue(id, data => {
      categories.push(gist.primaryCategory)
      var removeFromQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.mediaType === 'EPISODIC' ? 'Episode' : 'Video',
        contentDuration: gist.runtime,
        playbackType: 'Streamed'
      }
      creditBlocks.forEach(creditBlock => {
        if(creditBlock.title.trim().toLowerCase() === 'director'){
          removeFromQueueEventData.directorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
        if(creditBlock.title.trim().toLowerCase() === 'starring'){
          removeFromQueueEventData.actorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
        }
      })
      removeFromQueueEventData.contentGenre = categories.map(category => category && category.title).join(',')
      trackEvent('Removed From Watchlist', removeFromQueueEventData)
      this.setState({ isQueued: false })
    })
  }

  renderCrew(creditBlocks) {
    return _.map(creditBlocks, (c, i) => {
      if (!c.credits)
        return

      var schemaRole = c.title === 'starring' ? 'actor' : c.title

      return (
        <div key={i}>
          <div className="role">{c.title}</div>
          <div className="people">
            { _.map(c.credits, (credit, i) => {
                return <span key={i} itemProp={schemaRole}>{credit.title}</span>
              })
            }
          </div>
        </div>
      )
    })
  }

  render() {
    const video = this.state.video
    if(video === undefined) return <div>Stop returning malformed videos</div>;
    const showSubscribeOption = this.state.user && this.state.user.isSubscribed && video.pricing && video.pricing.type && video.pricing.type.includes("SVOD+");
    let purchased =  this.state.user && this.state.purchased;
    const watchNow = this.state.user && this.state.watchNow

    
    let showPlayButton;
    if(purchased){
      showPlayButton = true
    }
    if (this.state.video && this.state.video.gist.scheduleStartDate && (this.state.video.gist.scheduleStartDate - Date.now() > 0)) {
      showPlayButton = false;
    }
    
    if (!video)
      return <div className="video-module">Video data not available</div>

    if (_.get(this.state.user, 'subscription.subscriptionInfo.subscriptionStatus') === 'INACTIVE')
      window.sessionStorage.setItem('openUpdatecard', true)

    const previewSettings = window.settings.features.free_preview
    const showPreview = previewSettings && previewSettings.isFreePreview;
    const previewshowUnit = previewSettings && previewSettings.length.unit

    if (previewSettings) {
      var multiplier = parseInt(previewSettings.length.multiplier, 10)
      var previewShowTime = (previewshowUnit === "Minutes") ? multiplier * 60 : multiplier
    }

    const gist = video.gist

    const categoryTitle = _.get(gist.primaryCategory, 'title', '')

    const creditBlocks = filterCredits(video.creditBlocks)

    const trailerSrc = {
      id: gist.id,
      siteId: window.settings.siteId,
      permalink: gist.permalink,
      videoTag: _.get(window.settings, 'advertising.videoAdTag', ''),
      category: categoryTitle,
      title: _.get(video.contentDetails, 'trailers[0].title'),
      videoId: _.get(video.contentDetails, 'trailers[0].id'),
      trailerImage:_.get(video.contentDetails, 'trailers[0].videoImageUrl')
    }

    const contentDetails = video.contentDetails

    let trailerImageUrl = ''
    if (contentDetails.widgetImage) {
      trailerImageUrl = contentDetails.widgetImage.url
    } else if (contentDetails.videoImage) {
      trailerImageUrl = trailerSrc.trailerImage
    }
   
    return <div itemScope itemType="http://schema.org/Movie" className="video-player-with-info-01">
      {this.helmet}

      <div className="header">
        <div className="video-module-wrapper">
          <div className="header-info">
            <h1 itemProp="name" className="header-title">
              {gist.title}
            </h1>
            <span className="header-details">
              {gist.runtime && <span>{`${Math.round(gist.runtime / 60)}mins`}</span>}
              {gist.year && <span>{gist.year}</span>}
              {categoryTitle && <span itemProp="genre">
                  {categoryTitle}
                </span>}
            </span>
            {video.parentalRating && <span className="parental-rating">
                {video.parentalRating.replace("_", "")}
              </span>}
          </div>
        </div>
      </div>

      <div className="video-module-wrapper">
        {video && !video.gist.free && video.pricing && (video.pricing.rent || video.pricing.purchase) && !showSubscribeOption && !watchNow ? 
          this.renderPurchaseOptions(video, purchased, showPlayButton, showSubscribeOption)
        : 
          <div className="video" onContextMenu={this.disableRightClick.bind(this)}>
            <VideoJSPlayer 
              {...this.state} 
              videoId={gist.id} 
              category={categoryTitle} 
              fileType={_.get(this.props, "layout.settings.fileType")} 
              modalOpen={this.state.isModelOpen} 
              isTrailer={false} 
              autoplay={true} 
              permalink={gist.permalink} 
              videoTag={_.get(window.settings, "advertising.videoTag")} 
              parentalRating={video.parentalRating} 
              previewTime={showPreview && previewShowTime} 
              isFree={gist.free} 
              closedCaptions={contentDetails.closedCaptions} 
              startTime={this.state.startTime} 
            />
          </div>
        }
      </div>          
      <div className="video-module-wrapper">
        <div className="info-container">
          <div className="video-info">
            <div className="details">
              {trailerSrc.videoId && <div className="trailer" style={{ backgroundImage: `url(${trailerImageUrl})` }} onClick={this.showTrailer}>
                  <div className="play-icon site-color">
                    <i className="ion-ios-play" />
                    <p className="trailer-copy">Trailer</p>
                  </div>
                  <div className="category site-color">{`${categoryTitle}`}</div>
                </div>}
              <div className="crew">
                {this.renderCrew(creditBlocks)}
              </div>
            </div>
            <div className="description" dangerouslySetInnerHTML={{ __html: gist.description }} />
          </div>
          <div className="sharing">
            <i className="ion-social-facebook" onClick={() => {
                this.socialShare("Facebook");
              }} />
            <i className="ion-social-twitter" onClick={() => {
                this.socialShare("Twitter");
              }} />
            <i className="ion-ios-email-outline" onClick={() => {
                this.socialShare("Email");
              }} />
            {this.state.user && (this.state.isQueued ? <div className="remove-watchlist site-color" onClick={this.removeFromQueue}>
                  {" "}
                  <RemoveFromWatchlistIcon />
                </div> : <div className="add-watchlist site-color" onClick={this.addToQueue}>
                  {" "}
                  <AddToWatchlistIcon />
                </div>)}
          </div>
        </div>
        {trailerSrc.videoId && this.state.isModelOpen && <Modal title={trailerSrc.title} shown={this.state.isModelOpen} closeModal={this.showTrailer} className="modal-anim" children={<VideoJSPlayer {...trailerSrc} autoplay={true} fileType={_.get(this.props, "layout.settings.fileType")}  isTrailer={true} modalOpen={this.state.isModelOpen} />} />}
      </div>
    </div>;
  }

  socialShare(platform){
    const { gist = {}, creditBlocks = [], categories = [] } = this.state.video
    categories.push(gist.primaryCategory)
    var videoEventData = {
      contentId: gist.id,
      contentTitle: gist.title,
      contentType: gist.isTrailer ? 'Trailer' : gist.mediaType === 'EPISODIC' ? 'Episode' : 'Movie Video',
      contentDuration: gist.runtime,
      playbackType: 'Streamed'
    }
    creditBlocks.forEach(creditBlock => {
      if(creditBlock.title.trim().toLowerCase() === 'director'){
        videoEventData.directorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
      }
      if(creditBlock.title.trim().toLowerCase() === 'starring'){
        videoEventData.actorName = creditBlock.credits && creditBlock.credits.length > 0 ? creditBlock.credits.map(it => it.title).join(',') : ''
      }
    })
    videoEventData.contentGenre = categories.map(category => category && category.title).join(',')
    videoEventData.medium = platform
    switch(platform){
      case 'Facebook':
        share.facebook(window.location.href)
        break;
      case 'Twitter':
        share.twitter(window.location.href, gist.title)
        break;
      case 'Email':
        share.email(window.location.href)
        break;
      default:  
      break;
    }
    trackEvent('Shared', videoEventData)
  }

  get helmet() {
    const { gist = {}, seo = {} } = this.state.video

    return(
      <Helmet>
        <title>{`${seo.title || gist.title} | ${window.settings.site}`}</title>
        <meta name="description" content={seo.description || gist.description} />
        { seo.keywords &&
          <meta name="keywords" content={seo.keywords.join(',')}/>
        }
        <meta property="og:type" content="video.movie" />
        <meta property="og:title" content={seo.title || gist.title} />
        <meta property="og:description" content={seo.description || gist.description} />
        <meta property="og:image" content={gist.posterImageUrl || gist.videoImageUrl} />
      </Helmet>
    )
  }

  renderPurchaseOptions(video, purchased, showPlayButton, showSubscribeOption){
    const background = {
      backgroundImage: `url(${video.gist.videoImageUrl})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }
    return (
      <div style={{ position: 'relative', background: '#100101' }}>
        {(video && video.gist.scheduleStartDate && video.gist.scheduleStartDate - Date.now() > 0) &&
          <Timer
            header="Time until this video is available!"
            startTime={video.gist.scheduleStartDate}
            hide={() => this.setState({ startPlaying: true })}
          />
        }
        {this.state.purchased !== undefined && !purchased &&
          <div className={`transaction-options ${!showSubscribeOption && 'subscriptions'}`}>
            <Overlay
              content={this.state.video}
              watchNow={() => {
                popup.hide();
                this.setState({ watchNow: true });
                playVideo(this.state.user.userId, video.gist.id);
              }}
              purchased={() =>
                this.setState({ purchased: true })
              }
            />
          </div>
        }
        <div className="video-player-bg" style={background}>
          {showPlayButton &&
            <div className="play-icon-overlay"
              onClick={() => {
                playVideo(this.state.user.userId, video.gist.id);
                this.setState({ watchNow: true });
              }}>
              <PlayCircleSvg />
            </div>
          }
          {video.gist.scheduleStartDate && video.gist.scheduleStartDate - Date.now() > 0 && purchased &&
            <div className="purchased-copy">
              <p>You have purchased this video</p>
              <p>Sit back, and enjoy when it starts</p>
            </div>
          }
        </div>
      </div>
    )
  }
}


connect(VideoPlayerWithInfo01, state => ({ user: state.user }), userStore)

export default VideoPlayerWithInfo01